/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DelegateTransferRequest} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/delegate_transfer.pb'
import {DelegateTransferResponse} from '@cash-web/protos/squareup/cash/crow/api/v1beta1/delegate_transfer.pb'


export const delegateTransfer = (request: DelegateTransferRequest, options?: CashRequestOptions) => post<DelegateTransferRequest, DelegateTransferResponse>("/2.0/cash/delegate-transfer", request, {...options, rejectOnError: true })